const Saetze = require('./saetze.js');
import {formatPrice,checkAusbildung,zeitmodell} from "./logic";

class Eltern {

    constructor(dies, monate = 12) {
        this.dies = dies;
        this.monate = monate;
        this.allein = false;
        this.kinder = 0;
        this.fb_elt_verheiratet = Saetze.FREIBETRAG_ELTERNEINKOMMEN_VERHEIRATET;
        this.fb_elt_unverheiratet = Saetze.FREIBETRAG_ELTERNEINKOMMEN_UNVERHEIRATET;
        this.soz_rentner_beamte = Saetze.SOZIAL_RENTNER;
        this.soz_rentner_grenze = Saetze.SOZIAL_RENTNER_GRENZE;
        this.sozial_pauschale = Saetze.SOZIAL_PAUSCHALE;
        this.sozial_grenze = Saetze.SOZIAL_GRENZE;
        this.sozial_selbst = Saetze.SOZIAL_SELBSTST;
        this.sozial_selbst_grenze = Saetze.SOZIAL_SELBSTST_GRENZE;
        this.werbungskosten = Saetze.WERBUNGSKOSTEN;
        this.fb_kind = Saetze.FREIBETRAG_KIND;
        this.nichtselbst_mu = 0;
        this.selbst_mu = 0;
        this.renten_mu = 0;
        this.ekSteuer_mu = 0;
        this.kirchenSteuer_mu = 0;
        this.gewSteuer_mu = 0;
        this.nichtselbst_va = 0;
        this.selbst_va = 0;
        this.renten_va = 0;
        this.ekSteuer_va = 0;
        this.kirchenSteuer_va = 0;
        this.gewSteuer_va = 0;
    }

    get null() {
        return this.berechneNull();
    }
    /**
     * 0 zurückgeben
     * @returns {string}
     */
    berechneNull() {
        return formatPrice(0);
    }

    set anzKinder($this){
        this.kinder = $this.el$('Eltern.anzGeschwister').value
    }
    get anzKinder(){
        return this.kinder
    }

    set getrennt($this){
        this.allein = $this.el$('Eltern.verheiratet').value === 'nein'
    }
    get getrennt(){
        return this.allein
    }

    // WERTE MUTTER
    set einkommenNSM($this){
        this.nichtselbst_mu = $this.el$('Mutter.nichtSelbst').value
    }
    get einkommenNSM(){
        return parseFloat(this.nichtselbst_mu)
    }

    set einkommenSM($this){
        this.selbst_mu = $this.el$('Mutter.selbst').value
    }
    get einkommenSM(){
        return parseFloat(this.selbst_mu)
    }

    set rentenM($this){
        this.renten_mu = $this.el$('Mutter.beamte').value + $this.el$('Mutter.renten').value
    }
    get rentenM(){
        return parseFloat(this.renten_mu)
    }

    set EKM($this){
        this.ekSteuer_mu = $this.el$('Mutter.einkommenssteuer').value
    }
    get EKM(){
        return parseFloat(this.ekSteuer_mu)
    }

    set KIM($this){
        this.kirchenSteuer_mu = $this.el$('Mutter.kirchensteuer').value
    }
    get KIM(){
        return parseFloat(this.kirchenSteuer_mu)
    }

    set GWM($this){
        this.gewSteuer_mu = $this.el$('Mutter.gewerbesteuer').value
    }
    get GWM(){
        return parseFloat(this.gewSteuer_mu)
    }

    //WERTE VATER
    set einkommenNSV($this){
        this.nichtselbst_va = $this.el$('Vater.nichtSelbst').value
    }
    get einkommenNSV(){
        return parseFloat(this.nichtselbst_va)
    }

    set einkommenSV($this){
        this.selbst_va = $this.el$('Vater.selbst').value
    }
    get einkommenSM(){
        return parseFloat(this.selbst_va)
    }

    set rentenV($this){
        this.renten_va = $this.el$('Vater.beamter').value + $this.el$('Vater.renten').value
    }
    get rentenV(){
        return parseFloat(this.renten_va)
    }

    set EKV($this){
        this.ekSteuer_va = $this.el$('Vater.einkommenssteuer').value
    }
    get EKV(){
        return parseFloat(this.ekSteuer_va)
    }

    set KIV($this){
        this.kirchenSteuer_va = $this.el$('Vater.kirchensteuer').value
    }
    get KIV(){
        return parseFloat(this.kirchenSteuer_va)
    }

    set GWV($this){
        this.gewSteuer_va = $this.el$('Vater.gewerbesteuer').value
    }
    get GWV(){
        return parseFloat(this.gewSteuer_va)
    }

    get abzuege(){
        return this.calculateEltern()
    }
    calculateEltern() {
        // alle Werte abrufen und setzen
        this.anzKinder = this.dies
        this.getrennt = this.dies
        this.einkommenNSM = this.dies
        this.einkommenSM = this.dies
        this.rentenM = this.dies
        this.EKM = this.dies
        this.KIM = this.dies
        this.GWM = this.dies
        this.einkommenNSV = this.dies
        this.einkommenSV = this.dies
        this.rentenV = this.dies
        this.EKV = this.dies
        this.KIV = this.dies
        this.GWV = this.dies

        let summe = 0
        summe = this.EK_Vater + this.EK_Mutter

        if(!this.getrennt){
            summe -= this.fb_elt_verheiratet
        }

        //console.log('Summe Abzug Verh:'+summe)
        if(summe<0){
            summe = 0
        }

        return summe
    }

    get EK_Mutter(){
        let einkommen = 0;

        let abzugnichtSelbst = this.einkommenNSM * this.sozial_pauschale;
        if(abzugnichtSelbst>=this.sozial_grenze){ // prüfen, ob Soz-Grenze überschritten
            abzugnichtSelbst = this.sozial_grenze
        }
        abzugnichtSelbst = this.einkommenNSM - abzugnichtSelbst - (this.werbungskosten / 12 * this.monate)
        einkommen += abzugnichtSelbst > 0 ? (abzugnichtSelbst / this.monate) : 0;

        let abzugSelbst = this.einkommenSM * this.sozial_selbst;
        if(abzugSelbst>=this.sozial_selbst_grenze){ // prüfen, ob Soz-Grenze überschritten
            abzugSelbst = this.sozial_selbst_grenze
        }
        abzugSelbst = this.einkommenSM - abzugSelbst
        einkommen += abzugSelbst > 0 ? (abzugSelbst / this.monate) : 0;

        let abzugRente = this.rentenM * this.soz_rentner_beamte;
        if(abzugRente>=this.soz_rentner_grenze){ // prüfen, ob Soz-Grenze überschritten
            abzugRente = this.soz_rentner_grenze
        }
        abzugRente = this.rentenM - abzugRente
        einkommen += abzugRente > 0 ? (abzugRente / this.monate) : 0;

        einkommen -= ((this.EKM + this.KIM + this.GWM) / this.monate)

        if(this.anzKinder>0){
            einkommen -= this.anzKinder * this.fb_kind
        }

        if(this.getrennt){
            einkommen -= this.fb_elt_unverheiratet
        }

        //console.log('Einkommen Abzug Mutter:'+einkommen)
        if(einkommen<0){
            einkommen = 0
        }
        //console.log('Einkommen Abzug Mutter final:'+einkommen)
        return einkommen
    }

    get EK_Vater(){
        let einkommen = 0;

        let abzugnichtSelbst = this.einkommenNSV * this.sozial_pauschale;
        if(abzugnichtSelbst>=this.sozial_grenze){ // prüfen, ob Soz-Grenze überschritten
            abzugnichtSelbst = this.sozial_grenze
        }
        abzugnichtSelbst = this.einkommenNSV - abzugnichtSelbst - (this.werbungskosten / 12 * this.monate)
        einkommen += abzugnichtSelbst > 0 ? (abzugnichtSelbst / this.monate) : 0;

        let abzugSelbst = this.einkommenSV * this.sozial_selbst;
        if(abzugSelbst>=this.sozial_selbst_grenze){ // prüfen, ob Soz-Grenze überschritten
            abzugSelbst = this.sozial_selbst_grenze
        }
        abzugSelbst = this.einkommenSV - abzugSelbst
        einkommen += abzugSelbst > 0 ? (abzugSelbst / this.monate) : 0;

        let abzugRente = this.rentenV * this.soz_rentner_beamte;
        if(abzugRente>=this.soz_rentner_grenze){ // prüfen, ob Soz-Grenze überschritten
            abzugRente = this.soz_rentner_grenze
        }
        abzugRente = this.rentenV - abzugRente
        einkommen += abzugRente > 0 ? (abzugRente / this.monate) : 0;

        einkommen -= ((this.EKV + this.KIV + this.GWV) / this.monate)

        if(this.anzKinder>0){
            einkommen -= this.anzKinder * this.fb_kind
        }

        if(this.getrennt){
            einkommen -= this.fb_elt_unverheiratet
        }

        //console.log('Einkommen Abzug Vater:'+einkommen)
        if(einkommen<0){
            einkommen = 0
        }
        //console.log('Einkommen Abzug Vater final:'+einkommen)
        return einkommen
    }

}

function elternBerechnen_hilfe($this, aus){
    const el = new Eltern($this);
    if(aus){
        return el.null
    }else{
        if(checkAusbildung($this)==='meister'){ // Meister
            //console.log('eltern meister')
            return el.null
        }
        if(!zeitmodell($this)){ // Teilzeit
            //console.log('eltern teilzeit')
            return el.null
        }
        if($this.el$('Eltern.elternunabh').value === 'nein'){ // ohne Anrechnung Eltern
            //console.log('eltern ohne')
            return el.null
        }
        let abzuege = el.abzuege;
        if(abzuege<0){
            abzuege = 0
        }
        //console.log('Eltern ende: '+abzuege)
        return formatPrice(abzuege)
    }
}

function elternBerechnen($this, aus = false){
    $this.el$('results.eltern').value = elternBerechnen_hilfe($this, aus)
}

/**
 * Funktionen exportieren
 */
export {elternBerechnen};
